module.exports = __webpack_public_path__ + "d3532fa21f45b71423a115cfb1eae08f.png";